/* eslint-disable */ 
import _ from 'lodash'
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { monthEventFilter } from '../../../utils/functions';
import { MONTHS,ScheduleResultsHeaders } from '../../../utils/constants';
import  Navwrapper  from '../../../components/layout/Navigation';
import Footer from '../../layout/Footer';
import { getSeasonsRanking, getScheduleResultsBySeason } from '../api'
import { exportCSV, tableOptions} from '../common'
export class ScheduleResultsPage extends Component{

  constructor(props) {
    super(props);
    this.state = {
        currentSeason: "",
        seasons:[],
        eventsAll:[]
    };
    this.handleActiveSeasonChange = this.handleActiveSeasonChange.bind(this)
    this.setActiveSeasonsOptions  = this.setActiveSeasonsOptions.bind(this)
  }  

  componentWillMount(){

  }  

  componentDidMount (){
     const _this = this
     getSeasonsRanking().then(function(response) {
       const seasons = response.data 
      _this.setState({currentSeason:response.data[0].seasonName})  
       getScheduleResultsBySeason(seasons[0].seasonId).then(function(response){
          _this.setState({eventsAll: response.data})          
       })
      _this.setState({ seasons:seasons }) 
    })
  }

 divisionTeamFormatter(cell, row) {
   
   const currentSeason=''
   const eventNameOriginalValue = row.eventName;
   const eventName = eventNameOriginalValue.replace('#', 'No.'); // short term fix - encoding issue
   //console.log('eventName: ',eventName)
   var linkMen = `/teamStandings/${row.seasonId}/${row.eventId}/${eventName}/${row.eventSeason}/true`;
   var linkWomen = `/teamStandings/${row.seasonId}/${row.eventId}/${eventName}/${row.eventSeason}/false`;
    return (
            <div className="cellLinks">
                { row.teamStandingsMen
                  ? <Link className="cellLinksLeft" to={linkMen}>M</Link>
                  : <Link className="cellLinksLeft" to="#" style={{padding:10+'%'}}></Link>
                }            
                { row.teamStandingsWomen
                  ? <Link className="cellLinksLeft" to={linkWomen}>W</Link>
                  : <Link className="cellLinksLeft" to="#" style={{padding:10+'%'}}></Link>
                }                   
            </div>
          );   
  }

  divisionAverageFormatter(cell, row ) {

    var linkMen = `/eventAverage/${row.seasonId}/${row.eventId}/${row.eventName}/${row.eventSeason}/true`;
    var linkWomen = `/eventAverage/${row.seasonId}/${row.eventId}/${row.eventName}/${row.eventSeason}/false`;
    return (
      <div className="cellLinks">
      { row.averagesMen
        ? <Link className="cellLinksLeft" to={linkMen}>M</Link>
        : <Link className="cellLinksLeft" to="#" style={{padding:10+'%'}}></Link>
      }            
    { row.averagesWomen
        ? <Link className="cellLinksLeft" to={linkWomen}>W</Link>
        : <Link className="cellLinksLeft" to="#" style={{padding:10+'%'}}></Link>
      }                   
  </div>
           );
  }

setActiveSeasonsOptions()
  {
    const { seasons } = this.state
    const option = seasons.map((season) => {
      return(<option value={season.seasonId} key={season.seasonId}>{season.seasonName}</option>)
    })
    return option
  } 
handleActiveSeasonChange(event){
  const _this = this
  const seasonId = event.target.value 
  const selectedSeason = _.find(this.state.seasons,['seasonId',parseInt(seasonId)])
  _this.setState({currentSeason:selectedSeason.seasonName}) 
  getScheduleResultsBySeason(selectedSeason.seasonId).then(function(response){
    _this.setState({eventsAll: response.data})          
 })
}
  render() {
    const _this = this;
    const {eventsAll}=this.state;    
    var upcomingEventsLink = `/upcomingEvents/`;
    const eventsSep = eventsAll.filter( (event) => monthEventFilter(event, MONTHS.september));
    const eventsOct = eventsAll.filter( (event) => monthEventFilter(event, MONTHS.october));
    const eventsNov = eventsAll.filter( (event) => monthEventFilter(event, MONTHS.november));
    const eventsDec = eventsAll.filter( (event) => monthEventFilter(event, MONTHS.december));
    const eventsJan = eventsAll.filter( (event) => monthEventFilter(event, MONTHS.january));
    const eventsFeb = eventsAll.filter( (event) => monthEventFilter(event, MONTHS.february));
    const eventsMar = eventsAll.filter( (event) => monthEventFilter(event, MONTHS.march));
    const eventsApr = eventsAll.filter( (event) => monthEventFilter(event, MONTHS.april));
    // const eventsMay = eventsAll.filter( (event) => monthEventFilter(event, MONTHS.may));

    return (
      <div>
      <Navwrapper />
      <div className="container-fluid">
        <Row>
          <Col xs={12} >

            <div className="pageHeading" >

                  <div className="archiveDropDown">
                      <div >
                        <div className="titleWrap">
                          <label className="archiveLabel">Past Season: </label>
                        </div>
                        <div className="valueWrap" >
                            <select onChange={this.handleActiveSeasonChange}>
                              {this.setActiveSeasonsOptions()}
                            </select>
                        </div>
                      </div>
                  </div>

                <h4>{this.state.currentSeason}</h4>
                  <h4 >
                    Intercollegiate Tournament Schedule / Results<br/>
                  </h4>
            </div>
            
          </Col>
        </Row> 
        <Row>    
          <Col xs={12} >
            <Tabs defaultActiveKey={1} id="tournament-schedule-results-tabs" >
              <Tab eventKey={1} title="September">
                <BootstrapTable 
                  data={eventsSep} 
                  striped 
                  hover 
                  options={tableOptions}
                  pagination               
                >
                  <TableHeaderColumn          
                    dataField="Id" 
                    isKey 
                    dataAlign="right" 
                    dataSort 
                    data-Visible="false"               
                    hidden                 
                  >ID
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="eventDate" dataSort width="14%" >DATE
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="eventName" dataSort  width="40%">EVENT NAME
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="location" dataSort  width="30%">LOCATION            
                  </TableHeaderColumn>              
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionTeamFormatter}  width="8%">TEAMS
                  </TableHeaderColumn>              
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionAverageFormatter}  width="8%">AVERAGES
                  </TableHeaderColumn>                            
                </BootstrapTable>
              </Tab>
              <Tab eventKey={2} title="October">
                <BootstrapTable 
                  data={eventsOct} 
                  striped 
                  hover 
                  options={tableOptions} 
                  pagination 
                >
                  <TableHeaderColumn 
                    dataField="id" 
                    isKey 
                    dataAlign="right" 
                    dataSort 
                    hidden 
                    width="50"
                  >ID
                  </TableHeaderColumn>          
                  <TableHeaderColumn dataField="eventDate" dataSort  width="14%">DATE
                  </TableHeaderColumn>
                  <TableHeaderColumn 
                    dataField="eventName" 
                    dataSort  
                    width="40%"
                  >EVENT NAME
                  </TableHeaderColumn>
                  <TableHeaderColumn 
                    dataField="location" 
                    dataSort  
                    width="30%"
                  >LOCATION            
                  </TableHeaderColumn>                            
                  <TableHeaderColumn 
                    dataField="id" 
                    dataFormat={this.divisionTeamFormatter}  
                    width="8%"
                  >TEAMS
                  </TableHeaderColumn>              
                  <TableHeaderColumn 
                    dataField="id" 
                    dataFormat={this.divisionAverageFormatter}  
                    width="8%"
                  >AVERAGES
                  </TableHeaderColumn>                            
                </BootstrapTable>
              </Tab>
              <Tab eventKey={3} title="November" >
              <BootstrapTable 
                data={eventsNov} 
                striped 
                hover 
                options={tableOptions} 
                pagination
              >
                  <TableHeaderColumn 
                    dataField="id" 
                    isKey 
                    dataAlign="right" 
                    dataSort 
                    hidden 
                    width="50"
                  >ID
                  </TableHeaderColumn>          
                  <TableHeaderColumn dataField="eventDate" dataSort width="14%">DATE
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="eventName" dataSort  width="40%">EVENT NAME
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="location" dataSort  width="30%">LOCATION            
                  </TableHeaderColumn>                            
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionTeamFormatter}  width="8%">TEAMS
                  </TableHeaderColumn>              
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionAverageFormatter}  width="8%">AVERAGES
                  </TableHeaderColumn>                            
              </BootstrapTable>
              </Tab>
              <Tab eventKey={4} title="December" >
              <BootstrapTable 
                data={eventsDec} 
                striped 
                hover 
                options={tableOptions} 
                pagination
              >
                  <TableHeaderColumn 
                    dataField="Id" 
                    isKey 
                    dataAlign="right" 
                    dataSort 
                    hidden 
                    width="50"
                  >ID
                  </TableHeaderColumn>          
                  <TableHeaderColumn dataField="eventDate" dataSort width="14%">DATE
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="eventName" dataSort  width="40%">EVENT NAME
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="location" dataSort  width="30%">LOCATION            
                  </TableHeaderColumn>                            
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionTeamFormatter}  width="8%">TEAMS
                  </TableHeaderColumn>              
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionAverageFormatter}  width="8%">AVERAGES
                  </TableHeaderColumn>                            
              </BootstrapTable>
              </Tab>        
              <Tab eventKey={5} title="January">
              <BootstrapTable 
                data={eventsJan} 
                striped 
                hover 
                options={tableOptions} 
                pagination
              >
                  <TableHeaderColumn 
                    dataField="Id" 
                    isKey 
                    dataAlign="right" 
                    dataSort 
                    hidden 
                    width="50"
                  >ID
                  </TableHeaderColumn>          
                  <TableHeaderColumn dataField="eventDate" dataSort width="14%">DATE
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="eventName" dataSort  width="40%">EVENT NAME
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="location" dataSort  width="30%">LOCATION            
                  </TableHeaderColumn>                            
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionTeamFormatter}  width="8%">TEAMS
                  </TableHeaderColumn>              
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionAverageFormatter}  width="8%">AVERAGES
                  </TableHeaderColumn>                            
              </BootstrapTable>
              </Tab>                    
              <Tab eventKey={6} title="February" >
              <BootstrapTable 
                data={eventsFeb} 
                striped 
                hover 
                options={tableOptions} 
                pagination
              >
                  <TableHeaderColumn 
                    dataField="Id" 
                    isKey 
                    dataAlign="right" 
                    dataSort 
                    hidden 
                    width="50"
                  >ID
                  </TableHeaderColumn>          
                  <TableHeaderColumn dataField="eventDate" dataSort width="14%">DATE
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="eventName" dataSort  width="40%">EVENT NAME
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="location" dataSort  width="30%">LOCATION            
                  </TableHeaderColumn>                            
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionTeamFormatter}  width="8%">TEAMS
                  </TableHeaderColumn>              
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionAverageFormatter}  width="8%">AVERAGES
                  </TableHeaderColumn>                            
              </BootstrapTable>
              </Tab>   
              <Tab eventKey={7} title="March" >
              <BootstrapTable 
                data={eventsMar} 
                striped={true} 
                hover={true} 
                options={tableOptions} 
                pagination={true}
              >
                  <TableHeaderColumn 
                    dataField="Id" 
                    isKey={true} 
                    dataAlign="right" 
                    dataSort={true} 
                    hidden={true} 
                    width="50"
                  >ID
                  </TableHeaderColumn>          
                  <TableHeaderColumn dataField="eventDate" dataSort={true} width="10%">DATE
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="eventName" dataSort={true}  width="40%">EVENT NAME
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="location" dataSort={true}  width="30%">LOCATION            
                  </TableHeaderColumn>                            
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionTeamFormatter}  width="10%">TEAMS
                  </TableHeaderColumn>              
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionAverageFormatter}  width="10%">AVERAGES
                  </TableHeaderColumn>                            
              </BootstrapTable>
              </Tab> 
              <Tab eventKey={8} title="April" >
              <BootstrapTable 
                data={eventsApr} 
                striped={true} 
                hover={true} 
                options={tableOptions} 
                pagination={true}
              >
                  <TableHeaderColumn 
                    dataField="id" 
                    isKey={true} 
                    dataAlign="right" 
                    dataSort={true} 
                    hidden={true} 
                    width="50"
                  >ID
                  </TableHeaderColumn>          
                  <TableHeaderColumn dataField="eventDate" dataSort={true} width="10%">DATE
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="eventName" dataSort={true}  width="40%">EVENT NAME
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="location" dataSort={true}  width="30%">LOCATION            
                  </TableHeaderColumn>                            
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionTeamFormatter}  width="10%">TEAMS
                  </TableHeaderColumn>              
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionAverageFormatter}  width="10%">AVERAGES
                  </TableHeaderColumn>                            
              </BootstrapTable>
              </Tab>

              {/* <Tab eventKey={9} title="May" >
              <BootstrapTable 
                data={eventsMay} 
                striped={true} 
                hover={true} 
                options={tableOptions} 
                pagination={true}
              >
                  <TableHeaderColumn 
                    dataField="id" 
                    isKey={true} 
                    dataAlign="right" 
                    dataSort={true} 
                    hidden={true} 
                    width="50"
                  >ID
                  </TableHeaderColumn>          
                  <TableHeaderColumn dataField="eventDate" dataSort={true} width="10%">DATE
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="eventName" dataSort={true}  width="40%">EVENT NAME
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="location" dataSort={true}  width="30%">LOCATION            
                  </TableHeaderColumn>                            
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionTeamFormatter}  width="10%">TEAMS
                  </TableHeaderColumn>              
                  <TableHeaderColumn dataField="id" dataFormat={this.divisionAverageFormatter}  width="10%">AVERAGES
                  </TableHeaderColumn>                            
              </BootstrapTable>
              </Tab> */}
              { exportCSV(eventsAll,ScheduleResultsHeaders,'Schedule-Results.csv') }
            </Tabs>
          </Col>
        </Row>         
      </div>
      <Footer />
    </div>
   
    ); }
}



// WEBPACK FOOTER //
// ./src/components/pages/scheduleresults/index.js